import { useListState } from '@mantine/hooks';
import { useState, useEffect } from 'react';
import { CustomEventState } from '../../Types/EventT';
import { EventS } from '../EventS';

// eslint-disable-next-line import/prefer-default-export
export const useEventStates = () => {
  const [loading, setLoading] = useState(true);
  const [states, handlers] = useListState<CustomEventState>([]);
  const { setState, append, applyWhere, filter } = handlers;
  const stateLabels = states.map((state) => state.label);
  const { length } = states;

  useEffect(() => {
    EventS.fetchEventStates()
      .then(setState)
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateState = (state: CustomEventState) =>
    applyWhere(
      (eventState) => eventState.id === state.id,
      () => state,
    );

  const deleteState = (id: string) => filter((state) => state.id !== id);

  return { loading, states, stateLabels, length, append, updateState, deleteState };
};
